import { Link } from 'gatsby'
import React from 'react'
import { classNames } from '../utils'

interface NavItem {
  name: string
  slug: string
}

interface SubNavProps {
  navItems: Readonly<NavItem[]>
  subCategoryItems?: Readonly<NavItem[]>
  path?: string
  subPath?: string
}

export const SubNav = ({
  navItems,
  path,
  subPath,
  subCategoryItems,
}: SubNavProps) => {
  return (
    <div className="container mx-auto mb-4 mt-8 flex h-auto flex-col overflow-x-auto bg-default-1000 px-4 text-default-50 sm:px-6 md:overflow-x-visible">
      <div className="">
        <nav className="h-full w-full" aria-label="Resources sub nav">
          <ul className="flex h-full w-full list-none flex-wrap items-center gap-x-8 gap-y-4 text-xs">
            <li className="flex-shrink-0">
              <Link
                to="/resources/latest"
                activeClassName="text-primary-400"
                partiallyActive
                className={classNames('hover:text-primary-400')}
              >
                Resources
              </Link>
            </li>
            {navItems.map((item) => (
              <li className="flex-shrink-0 last-of-type:pr-4" key={item.slug}>
                <Link
                  to={path ? `/${path}/${item.slug}/` : `/${item.slug}/`}
                  activeClassName="text-primary-400"
                  partiallyActive
                  className={classNames('hover:text-primary')}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      </div>
      <div className="my-m border-b border-b-default-400"></div>
      {subCategoryItems && (
        <nav
          className="flex h-full w-full gap-x-s text-xxxxs"
          aria-label="Resources sub categories"
        >
          Categories:
          <ul className="flex h-full w-full list-none flex-wrap items-center gap-x-s gap-y-4">
            {subCategoryItems.map((item) => (
              <li className="flex-shrink-0 last-of-type:pr-4" key={item.slug}>
                <Link
                  to={
                    subPath
                      ? `/${path}/${subPath}/${item.slug}/`
                      : `/${item.slug}/`
                  }
                  activeClassName="bg-primary text-default-1000 border-primary"
                  partiallyActive
                  className={classNames(
                    'h-4 items-center justify-center rounded border border-default-800 bg-default-800 px-xs py-xxxs text-xxxxs !leading-none text-default-50 hover:border-primary hover:bg-primary hover:text-default-1000'
                  )}
                >
                  {item.name}
                </Link>
              </li>
            ))}
          </ul>
        </nav>
      )}
    </div>
  )
}
